import type { ComponentProps } from 'react';
import { Text, Title } from 'ui';
import { UserLink } from '../user-link';

type P = {
  type?: 'text' | 'title';
} & ComponentProps<typeof UserLink>;

const UserNameLink = ({ children, type = 'title', ...rest }: P) => (
  <UserLink {...rest}>
    {type === 'title' ? (
      <Title level={4}>{children}</Title>
    ) : (
      <Text type="title" weight="medium">
        {children}
      </Text>
    )}
  </UserLink>
);

export default UserNameLink;
